import React, { FC, RefObject, useCallback, useEffect } from 'react'
import styles from './CartBar.module.scss'
import { ICartItem } from '../../../../../modules/cart/domain/models/ICart';
import { Button } from '@mui/material';
import { IExtract } from '../../../../../modules/consume/domain/models/Extract';
import CartToast from '../../cartToast/CartToast';
import { useCartStore } from '../../../../../modules/cart/infra/store/CartStore';
import { IDevice } from '../../../../../modules/device/interface/Device';
import { OperationMode } from '../../../../../modules/device/presentation/context/OperationMode';
import { useI18n } from '../../../../../hooks/useI18n';
import { moneyMaskNumber } from '../../../../../services/utils/Money';
export interface ICartBarProps {
    //propertys
    operationMode?: OperationMode;
    disabledPayment?: boolean;
    onClickSendButton: (cartItem: ICartItem[]) => void;
    onClickCloseAccountButton?: () => void;
    onClickPayAccountButton?: () => void;
    onClick?: () => void;
    visible?: boolean;
    className?: string;
    extract?: IExtract;
    number?: string;
    device?: IDevice;
    callTutorial?: (type: "SEND_ORDER", ref: RefObject<HTMLDivElement>) => void
}
const CartBar: FC<ICartBarProps> = ({ onClickSendButton, onClickCloseAccountButton, onClickPayAccountButton, extract, className, visible, number, onClick, disabledPayment, callTutorial }) => {
    const { t } = useI18n();
    const [cartItems, totals] = useCartStore(state => [state.cartItems, state.totals]);

    const containerRef = React.useRef<HTMLDivElement | null>(null);

    const onClickSendButtonHandle = useCallback(() => {
        onClickSendButton(cartItems)
    }, [onClickSendButton, cartItems])

    const onClickCloseAccountButtonHandle = useCallback(() => {
        onClickCloseAccountButton?.()
    }, [onClickCloseAccountButton])

    const onClickPayAccountButtonHandle = useCallback(() => {
        onClickPayAccountButton?.()
    }, [onClickPayAccountButton]);

    const callTutorialHandler = useCallback(() => {
        if (totals.totalQuantity) {
            callTutorial?.("SEND_ORDER", containerRef)
        }
    }, [callTutorial, totals.totalQuantity])

    useEffect(() => {
        callTutorialHandler();
    }, [callTutorialHandler])


    return (
        <div id={styles.CartBar} ref={containerRef} className={`${(totals.totalQuantity || visible) ? styles.CartBarVisible : styles.CartBarHidden} ${className}`} onClick={onClick} >
            <CartToast />
            {!!cartItems.length &&
                <>
                    <div className={styles.resume}>
                        <b>{moneyMaskNumber(totals.totalPrice)}</b>
                        <span>{t('catalog.totalItems')}: {totals.totalQuantity}</span>
                    </div>
                    <div className={styles.buttons}>
                        <Button variant='outlined' color='primary' className={styles.outlined} disabled={!totals.totalQuantity} onClick={onClickSendButtonHandle}>
                            {t('catalog.sendOrder')}
                        </Button>
                    </div>
                </>
            }
            {onClickCloseAccountButton && extract && !extract?.totalToPayWithoutFee && !cartItems.length &&
                <>
                    <div className={styles.resume}>
                        <span>{t('catalog.totalPaid')}:</span>
                        <b>{moneyMaskNumber(extract?.paidAmount)}</b>
                    </div>
                    <div className={styles.buttons}>

                        <Button variant='contained' color='primary' disabled={!extract} classes={
                            {
                                root: styles.contained,
                                disabled: styles.disabled
                            }

                        } onClick={onClickCloseAccountButtonHandle}>
                            {t('catalog.finishTable')}
                        </Button>
                    </div>
                </>
            }
            {
                onClickCloseAccountButton && !!extract?.totalToPayWithoutFee && !cartItems.length && !disabledPayment &&
                <>
                    <div className={styles.resume}>
                        {number && <span>{t('catalog.table')}: <b>{number}</b></span>}
                        <span><b>{extract.user?.name}</b></span>
                        <span>{t('catalog.consumption')}: <b>{moneyMaskNumber(extract?.totalAmount)}</b></span>
                    </div>
                    <div className={styles.buttons}>

                        <Button variant='contained' color='primary' disabled={!extract} classes={
                            {
                                root: styles.contained,
                                disabled: styles.disabled
                            }
                        } onClick={onClickPayAccountButtonHandle}>
                            {t('catalog.makePayment')}
                        </Button>
                    </div>
                </>
            }
        </div>
    )
}
export default CartBar